import $ from 'jquery'
import { showMessage } from './message'

// 图片下载
function getBlob(url) {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest()

    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response)
      }
    }

    xhr.send()
  })
}
function saveAs(blob, filename) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename)
  } else {
    const link = document.createElement('a')

    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }))

    window.URL.revokeObjectURL(link.href)
  }
}
function BrowserInfo() {
  var userAgent = navigator.userAgent
  var json = {
    isAndroid: userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1,
    isIphone: !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    isWeixin: userAgent.match(/MicroMessenger/i) == "MicroMessenger",
  }
  return json;
}
function getDate(date) {
  if (!date) {
    return new Date()
  }

  var theDate = ''
  if (typeof date === 'number') {
    theDate = new Date(date)
  } else if (date.length === undefined) {
    theDate = date
  } else {
    if (date.length > 10) {
      var dateArr = date.split(/[T\s]/)

      var beforeTime = dateArr[0].split('-')
      var afterTime = dateArr[1].split(':')

      afterTime[2] = afterTime[2] ? afterTime[2] : '00'
    } else {
      var beforeTime = date.split('-')
    }

    if (afterTime) {
      theDate = new Date(beforeTime[0], beforeTime[1] - 1, beforeTime[2], afterTime[0], afterTime[1], afterTime[2])
    } else {
      theDate = new Date(beforeTime[0], beforeTime[1] - 1, beforeTime[2])
    }
  }

  if (!theDate) {
    theDate = new Date()
  }

  return theDate
}
export default {
  getDate: getDate,
  BrowserInfo: BrowserInfo,
  /**
       * 格式化日期函数
       * @param date {Date|Date String} [需要格式化的日期]
       * @param frm {String} [格式(如：yyyy-MM-dd hh:mm:ss)]
       * @return 格式化后的日期
       */
  formatDate(date, fmt) {
    fmt = fmt || 'yyyy-MM-dd hh:mm:ss'
    if (!date || !fmt) {
      return false
    }

    let theDate = getDate(date)
    var o = {
      'M+': theDate.getMonth() + 1, // 月份
      'd+': theDate.getDate(), // 日
      'h+': theDate.getHours(), // 小时
      'm+': theDate.getMinutes(), // 分
      's+': theDate.getSeconds(), // 秒
      'q+': Math.floor((theDate.getMonth() + 3) / 3), // 季度
      'S': theDate.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (theDate.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  },
  formDataDate(str) {
    var dateStr = getDate(str)
    var year = dateStr.getFullYear()
    var monthStr = dateStr.getMonth() + 1
    var dayStr = dateStr.getDate()
    var month = monthStr < 10 ? '0' + monthStr : monthStr
    var day = dayStr < 10 ? '0' + dayStr : dayStr
    return year + '-' + month + '-' + day
  },
  formMonthDate(str) {
    var dateStr = getDate(str)
    var year = dateStr.getFullYear()
    var monthStr = dateStr.getMonth() + 1
    var dayStr = dateStr.getDate()
    var month = monthStr < 10 ? '0' + monthStr : monthStr
    return year + '-' + month
  },
  formDataTime(str) {
    var dateStr = getDate(str)
    var hours = dateStr.getHours()
    var minutes = dateStr.getMinutes()
    var seconds = dateStr.getSeconds()
    hours = hours < 10 ? '0' + hours : hours
    minutes = minutes < 10 ? '0' + minutes : minutes
    seconds = seconds < 10 ? '0' + seconds : seconds
    return hours + ':' + minutes + ':' + seconds
  },
  getDateDiff(dateStr) {
    var publishTime = parseInt(getDate(dateStr).getTime() / 1000),
      d_seconds,
      d_minutes,
      d_hours,
      d_days,
      d,
      timeNow = parseInt(new Date().getTime() / 1000)

    d = timeNow - publishTime;
    d_days = parseInt(d / 86400);
    d_hours = parseInt(d / 3600);
    d_minutes = parseInt(d / 60);
    d_seconds = parseInt(d);

    if (d_days > 0 && d_days < 30) {
      return d_days + '天前';
    } else if (d_days <= 0 && d_hours > 0) {
      return d_hours + '小时前';
    } else if (d_hours <= 0 && d_minutes > 0) {
      return d_minutes + '分钟前';
    } else if (d_seconds < 60) {
      if (d_seconds <= 0) {
        return '刚刚发表';
      } else {
        return d_seconds + '秒前';
      }
    } else if (d_days >= 30 && d_days < 365) {
      return Math.floor(d_days / 30) + '个月前';
    } else if (d_days >= 365) {
      return Math.floor(d_days / 365) + '年前';
    }
  },

  /**
     * 获取上一个月
     *
     * @date 格式为yyyy-mm-dd的日期，如：2014-01-25
     */
  getPreMonth(date) {
    var arr = date.split('-')
    var year = arr[0] // 获取当前日期的年份
    var month = arr[1] // 获取当前日期的月份
    var days = new Date(year, month, 0)
    days = days.getDate() // 获取当前日期中月的天数
    var year2 = year
    var month2 = parseInt(month) - 1
    if (month2 == 0) {
      year2 = parseInt(year2) - 1
      month2 = 12
    }
    var days2 = new Date(year2, month2, 0)
    days2 = days2.getDate()
    if (month2 < 10) {
      month2 = '0' + month2
    }
    var t2 = year2 + '-' + month2
    return t2
  },
  /**
     * 获取下一个月
     *
     * @date 格式为yyyy-mm的日期，如：2014-01
     */
  getNextMonth(date) {
    var arr = date.split('-')
    var year = arr[0] // 获取当前日期的年份
    var month = arr[1] // 获取当前日期的月份
    var days = new Date(year, month, 0)
    days = days.getDate() // 获取当前日期中的月的天数
    var year2 = year
    var month2 = parseInt(month) + 1
    if (month2 == 13) {
      year2 = parseInt(year2) + 1
      month2 = 1
    }
    var days2 = new Date(year2, month2, 0)
    days2 = days2.getDate()
    if (month2 < 10) {
      month2 = '0' + month2
    }

    var t2 = year2 + '-' + month2
    return t2
  },
  rangeFn: function (n) {
    n = n.toString()
    return n[1] ? n : '0' + n
  },

  downloadFile(url, filename) {
    getBlob(url).then(blob => {
      saveAs(blob, filename)
    })
  },
  getUrlPara(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
    let r = window.location.search.substr(1).match(reg)

    if (r != null) {
      return (r[2])
    }

    return null;
  },
  openApp(callback) {
    let url = window.location
    let openUrl = ''
    var browser = BrowserInfo();
    if (browser.isAndroid) {
      openUrl = "myscheme://myhost:1024/main?appUrl=" + url.href
      //检查app是否打开
      function checkOpen(cb) {
        var _clickTime = +(new Date());
        function check(elsTime) {
          if (elsTime > 3000 || document.hidden || document.webkitHidden) {
            cb(1);
          } else {
            cb(0);
          }
        }
        //启动间隔20ms运行的定时器，并检测累计消耗时间是否超过3000ms，超过则结束
        var _count = 0, intHandle;
        intHandle = setInterval(function () {
          _count++;
          var elsTime = +(new Date()) - _clickTime;
          if (_count >= 100 || elsTime > 3000) {
            clearInterval(intHandle);
            check(elsTime);
          }
        }, 20);
      }
      //在iframe 中打开APP
      var ifr = document.createElement('iframe');
      ifr.src = openUrl;
      ifr.style.display = 'none';

      if (callback) {
        if (browser.isWeixin) {
          showMessage('请在浏览器中打开App')
        } else {
          checkOpen(function (opened) {
            callback && callback(opened);
          });
        }
      }

      document.body.appendChild(ifr);

      setTimeout(function () {
        document.body.removeChild(ifr);
      }, 2000);
    }

    if (browser.isIphone) {
      if (browser.isWeixin) {
        showMessage('请在浏览器中打开App')
        return
      }

      openUrl = "https://temp.chinavisionary.com/my/downloadApp/?appUrl=" + url.href
      window.location.href = openUrl
    }
  }
}
export function debounce(fn, delay) {
  let timeout = null
  return function () {
    let args = arguments
    if (timeout) window.clearTimeout(timeout)
    timeout = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}
